import { redirect, redirectDocument } from 'react-router';
import { useAppStore } from '@halo/chat-sdk-react';
import { MyTrans } from '@halo/ui-react';
import CallsIcon from '@/assets/images/menu/call.svg?react';
import CallsOnIcon from '@/assets/images/menu/callOn.svg?react';
import ContactsIcon from '@/assets/images/menu/contacts.svg?react';
import ContactsOnIcon from '@/assets/images/menu/contactsOn.svg?react';
import DocsIcon from '@/assets/images/menu/docs.svg?react';
import DocsOnIcon from '@/assets/images/menu/docsOn.svg?react';
import FeedsIcon from '@/assets/images/menu/feeds.svg?react';
import FeedsOnIcon from '@/assets/images/menu/feedsOn.svg?react';
import MessagesIcon from '@/assets/images/menu/message.svg?react';
import MessagesOnIcon from '@/assets/images/menu/messageOn.svg?react';
import ShortsIcon from '@/assets/images/menu/shorts.svg?react';
import ShortsOnIcon from '@/assets/images/menu/shortsOn.svg?react';
import WalletIcon from '@/assets/images/menu/wallet.svg?react';
import WalletOnIcon from '@/assets/images/menu/walletOn.svg?react';
import { genRouteMap } from '@/scripts/router';
import { checkUrlFromAccountCenter } from '@/pages/login/helpers';
// import MyTrans from '@/components/MyTrans';
import { userApis } from '../apis/user';
import { ActionKeys } from './actions';
import Paths from './paths';

export const routeMap = genRouteMap({
  [Paths.BASE]: {
    loader: async ({ request }) => {
      const url = new URL(request.url);
      const isFromAccountCenter = checkUrlFromAccountCenter();

      if (userApis.isLogin()) {
        if (
          ['', Paths.LOGIN, Paths.MAIN, Paths.MESSAGES].some((path) =>
            new RegExp(`^${path}/?$`).test(url.pathname)
          ) &&
          !isFromAccountCenter
        ) {
          return redirect(Paths.MESSAGES_CHATS);
        }
      } else if (url.pathname !== Paths.LOGIN) {
        const { winPromise } = useAppStore.getState();
        const disabled = await winPromise;
        if (!disabled) {
          return redirectDocument(Paths.LOGIN);
        }
      }

      return null;
    },
  },
  [Paths.MAIN]: {},
  // Login
  [Paths.LOGIN]: {},
  [Paths.AUTH_CALLBACK]: {},
  // Kick out page
  [Paths.KICK_OUT]: {},
  // Error page
  [Paths.ERROR]: {},
  // Calls
  [Paths.CALLS]: {
    auth: {
      key: Paths.CALLS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: (
        <div>
          <MyTrans i18nKey="nav.calls"></MyTrans>
        </div>
      ),
      icon: <CallsIcon />,
      activeIcon: <CallsOnIcon />,
    },
  },
  // Messages
  [Paths.MESSAGES]: {
    auth: {
      key: Paths.MESSAGES,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: (
        <div>
          <MyTrans i18nKey="nav.messages"></MyTrans>
        </div>
      ),
      icon: <MessagesIcon />,
      activeIcon: <MessagesOnIcon />,
    },
  },
  [Paths.MESSAGES_CHATS]: {
    path: Paths.MESSAGES_CHATS + '/:chat_id?',
    auth: {
      key: Paths.MESSAGES_CHATS,
      actions: [ActionKeys.VIEW],
    },
  },
  // Contacts
  [Paths.CONTACTS]: {
    auth: {
      key: Paths.CONTACTS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: (
        <div>
          <MyTrans i18nKey="nav.contacts"></MyTrans>
        </div>
      ),
      icon: <ContactsIcon />,
      activeIcon: <ContactsOnIcon />,
    },
  },
  [Paths.CONTACTS_GROUP_CHAT]: {
    path: Paths.CONTACTS_GROUP_CHAT,
    auth: {
      key: Paths.CONTACTS_GROUP_CHAT,
      actions: [ActionKeys.VIEW],
    },
  },
  [Paths.FEEDS]: {
    auth: {
      key: Paths.FEEDS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: (
        <div>
          <MyTrans i18nKey="nav.feeds"></MyTrans>
        </div>
      ),
      icon: <FeedsIcon />,
      activeIcon: <FeedsOnIcon />,
    },
  },
  [Paths.SHORTS]: {
    auth: {
      key: Paths.SHORTS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: (
        <div>
          <MyTrans i18nKey="nav.shorts"></MyTrans>
        </div>
      ),
      icon: <ShortsIcon />,
      activeIcon: <ShortsOnIcon />,
    },
  },
  [Paths.DOCS]: {
    menu: {
      label: (
        <div>
          <MyTrans i18nKey="nav.docs"></MyTrans>
        </div>
      ),
      icon: <DocsIcon />,
      activeIcon: <DocsOnIcon />,
    },
  },
  [Paths.WALLET]: {
    auth: {
      key: Paths.WALLET,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: (
        <div>
          <MyTrans i18nKey="nav.wallet"></MyTrans>
        </div>
      ),
      icon: <WalletIcon />,
      activeIcon: <WalletOnIcon />,
    },
  },
  [Paths.SETTINGS]: {
    loader: async ({ request }) => {
      const url = new URL(request.url);
      if (['', Paths.SETTINGS].some((path) => new RegExp(`^${path}/?$`).test(url.pathname))) {
        return redirect(Paths.SETTINGS_NOTIFICATIONS);
      }
      return null;
    },
    auth: {
      key: Paths.SETTINGS,
      actions: [ActionKeys.VIEW],
    },
  },
  [Paths.SETTINGS_NOTIFICATIONS]: {
    auth: {
      key: Paths.SETTINGS_NOTIFICATIONS,
      actions: [ActionKeys.VIEW],
    },
    // menu: {
    //   element: <Notifications />,
    // },
  },
  [Paths.SETTINGS_GENERAL]: {
    auth: {
      key: Paths.SETTINGS_GENERAL,
      actions: [ActionKeys.VIEW],
    },
    // menu: {
    //   element: <Notifications />,
    // },
  },
  [Paths.SETTINGS_SECURITY]: {
    auth: {
      key: Paths.SETTINGS_SECURITY,
      actions: [ActionKeys.VIEW],
    },
    // menu: {
    //   element: <Security />,
    // },
  },
  [Paths.SETTINGS_PRIVACY]: {
    auth: {
      key: Paths.SETTINGS_PRIVACY,
      actions: [ActionKeys.VIEW],
    },
    // menu: {
    //   element: <Privacy />,
    // },
  },
  [Paths.SETTINGS_SYNC_BACKUP]: {
    auth: {
      key: Paths.SETTINGS_SYNC_BACKUP,
      actions: [ActionKeys.VIEW],
    },
    // menu: {
    //   element: <Privacy />,
    // },
  },
  [Paths.SETTINGS_DEVICES]: {
    auth: {
      key: Paths.SETTINGS_DEVICES,
      actions: [ActionKeys.VIEW],
    },
    // menu: {
    //   element: <Devices />,
    // },
  },
  [Paths.SETTINGS_ABOUT]: {
    auth: {
      key: Paths.SETTINGS_ABOUT,
      actions: [ActionKeys.VIEW],
    },
    // menu: {
    //   element: <About />,
    // },
  },
  [Paths.SETTINGS_LANGUAGE]: {
    auth: {
      key: Paths.SETTINGS_LANGUAGE,
      actions: [ActionKeys.VIEW],
    },
    // menu: {
    //   element: <Language />,
    // },
  },
  [Paths.NOT_FOUND]: {
    path: Paths.NOT_FOUND,
    loader: async ({ request }) => {
      sessionStorage.setItem('deepLink', request.url);
      return redirect(Paths.MESSAGES_CHATS);
    },
  },
});
